const { BigQueryEventTypes } = require('../types');
const { createBaseUserActionEvent } = require('./base');

const {
    clickedOnTranslationButton,
    clickedOnCancelledTranslationButton
} = BigQueryEventTypes.translation;

const UserActionsBigQueryEvents = {
    clickedOnTranslationButton: (params) => createBaseUserActionEvent(
        clickedOnTranslationButton, params
    ),
    clickedOnCancelledTranslationButton: (params) => createBaseUserActionEvent(
        clickedOnCancelledTranslationButton, params
    )
};

module.exports = {
    UserActionsBigQueryEvents
};
